module.exports = "/_next/static/images/kw-841518c8d49f53db0c814c8dd1c8cdef.svg";